import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userToken: null,
  current_user: {},
  ixBiz: 0
};

const slice = createSlice({
  name: 'socketStates',
  initialState,
  reducers: {
    setSocketAuth(state, action) {
      state.userToken = action.payload.token;
      state.current_user = action.payload.current_user;
      state.ixBiz = action.payload.biz;
    },
    setUserToken(state, action) {
      state.userToken = action.payload;
    },
    setCurrentUser(state, action) {
      state.current_user = action.payload;
    },
    setIxBiz(state, action) {
      state.ixBiz = action.payload?.ixBiz ?? 0;
    },
    resetSocketState(state) {
      state.userToken = null;
      state.current_user = {};
      state.ixBiz = 0;
    }
  }
});
const socketReducer = slice.reducer;
export const {
  setSocketAuth,
  setUserToken,
  setCurrentUser,
  setIxBiz,
  resetSocketState
} = slice.actions;

export default socketReducer;
